import { MAX_INPUT_FIELD_LENGTH } from '@/entities/client';
import { ProfileFormSection } from '@/shared/ui/forms/profile-form-section';
import { UsAddressFields } from '@/shared/ui/forms/us-address-fields';

export function EditClientProfileFormAddress() {
    return (
        <ProfileFormSection title="Address">
            <UsAddressFields maxLength={MAX_INPUT_FIELD_LENGTH} />
        </ProfileFormSection>
    );
}
